import { grayColor } from 'assets/jss/material-dashboard-pro-react';
const bwodExtensionModalStyle = (theme) => ({
	extensionModal: {
		dialogHeader: {
			paddingTop: '0px !important',
		},
	},
	dialogBodyWrapper: {
		padding: '30px',
	},
	dialogHeaderWithText: {
		borderBottom: '0px !important',
	},
	basePlanWrapper: {},
	basePlanDetails: {
		'& .MuiTable-root' : {
			width: 'auto !important'
		},
		'& .MuiTableCell-root': {
			padding: '0px !important',
			borderBottom: 'none !important',
		},
		'& .MuiTableCell-root:nth-child(2)': {
			paddingLeft: '15px !important',
		},
	},
	addOnWrapper: {
		marginTop: '10px',
		background: grayColor[2],
		borderRadius:'5px'
	},
	addOnHeading: {
		padding: '20px',
		borderBottom: `1px solid ${grayColor[0]}`
	},
	addOnSelect: {
		padding: '20px',
		borderBottom: `1px solid ${grayColor[0]}`
		
	},
	radioOptions: {
		display: 'flex'
	},
	addOnDetails: {
		padding: '20px',
		'& .MuiTableCell-root': {
			padding: '0px !important',
			borderBottom: 'none !important',
		},
		'& .MuiTableCell-root:nth-child(2)': {
			paddingLeft: '15px !important',
		}
	},
	addOnDateWrapper: {
		display: 'flex',
	},
	leftSpace: {
		marginLeft:'10px !important'
	},
	submitAddOn: {
		marginTop: '20px',
		width: '100%'
	}
});

export default bwodExtensionModalStyle;
